export default __webpack_public_path__ + "static/media/22.9c8fb9b9.png";